class PriceRangeSlider extends HTMLElement {
  connectedCallback() {
    this.priceRangeSlider = this.querySelector('[data-price-range-slider]');
    this.minInput = this.priceRangeSlider.querySelector('[data-price-range-slider-min]');
    this.maxInput = this.priceRangeSlider.querySelector('[data-price-range-slider-max]');
    this.range = this.priceRangeSlider.querySelector('[data-price-range-slider-range]');
    this.minDisplay = this.querySelector('[data-price-range-display-min]');
    this.maxDisplay = this.querySelector('[data-price-range-display-max]');

    // Get param names from data attributes
    const minParamName = this.priceRangeSlider.dataset.minParam;
    const maxParamName = this.priceRangeSlider.dataset.maxParam;

    // Find the corresponding number inputs in the form
    this.minNumberInput = this.querySelector(`input[name="${minParamName}"]`);
    this.maxNumberInput = this.querySelector(`input[name="${maxParamName}"]`);

    // Add event listeners
    this.minInput.addEventListener('input', this.handleMinInput);
    this.maxInput.addEventListener('input', this.handleMaxInput);

    // Listen for changes to the number inputs
    this.minNumberInput.addEventListener('blur', this.handleNumberInputBlur);
    this.maxNumberInput.addEventListener('blur', this.handleNumberInputBlur);

    // Initialize range position
    this.updateNumberInputs();
  }

  handleNumberInputBlur = () => {
    const min = parseInt(this.minNumberInput.value);
    const max = parseInt(this.maxNumberInput.value);
    const minMin = parseInt(this.minInput.min);
    const maxMax = parseInt(this.maxInput.max);

    if (!min) {
      this.minNumberInput.value = this.minInput.min;
    }

    if (!max) {
      this.maxNumberInput.value = this.maxInput.max;
    }

    if (min > max) {
      this.minNumberInput.value = max - 1;
    }

    if (max < min) {
      this.maxNumberInput.value = min + 1;
    }

    if (min < minMin) {
      this.minNumberInput.value = minMin;
    }

    if (max > maxMax) {
      this.maxNumberInput.value = maxMax;
    }

    this.updateRange();
  };

  handleMinInput = () => {
    const min = parseInt(this.minInput.value);
    const max = parseInt(this.maxInput.value);

    if (min > max) {
      this.minInput.value = max - 1;
    }

    this.updateNumberInputs();
  };

  handleMaxInput = () => {
    const min = parseInt(this.minInput.value);
    const max = parseInt(this.maxInput.value);

    if (max < min) {
      this.maxInput.value = min + 1;
    }

    this.updateNumberInputs();
  };

  updateNumberInputs = () => {
    const min = parseInt(this.minInput.value);
    const max = parseInt(this.maxInput.value);
    const percent1 = (min / parseInt(this.minInput.max)) * 100;
    const percent2 = (max / parseInt(this.maxInput.max)) * 100;

    this.range.style.left = `${percent1}%`;
    this.range.style.width = `${percent2 - percent1}%`;

    // Update number inputs
    if (this.minNumberInput) this.minNumberInput.value = min;
    if (this.maxNumberInput) this.maxNumberInput.value = max;

    // Update display values
    if (this.minDisplay) this.minDisplay.textContent = min;
    if (this.maxDisplay) this.maxDisplay.textContent = max;
  };

  updateRange = () => {
    const min = parseInt(this.minNumberInput.value) || 0;
    const max = parseInt(this.maxNumberInput.value) || parseInt(this.maxInput.max);
    const percent1 = (min / parseInt(this.minInput.max)) * 100;
    const percent2 = (max / parseInt(this.maxInput.max)) * 100;

    this.range.style.left = `${percent1}%`;
    this.range.style.width = `${percent2 - percent1}%`;

    this.minInput.value = min;
    this.maxInput.value = max;
  };
}

customElements.define('price-range-slider', PriceRangeSlider);
